// extracted by mini-css-extract-plugin
export default {"Transition":"styles_Transition__hz57V"};